export enum TelemetryEventLabel {
  CANVAS_APP_STARTUP_PREVIEW_LATENCY = 'canvasAppStartupPreviewLatency',
  CANVAS_APP_STARTUP_COMMENT_LATENCY = 'canvasAppStartupCommentLatency',
  CANVAS_APP_SWITCH_PREVIEW_LATENCY = 'canvasAppSwitchPreviewLatency',
  CANVAS_APP_SWITCH_COMMENT_LATENCY = 'canvasAppSwitchCommentLatency',
  CANVAS_ELEMENT_CLICK_LATENCY = 'canvasElementClickLatency',
  CANVAS_ELEMENT_HOVER_LATENCY = 'canvasElementHoverLatency',
  COMPONENT_PREVIEW_RENDER_LATENCY = 'componentPreviewRenderLatency',
  NAVIGATOR_ELEMENT_HOVER_LATENCY = 'navigatorElementHoverLatency',
  KEYBOARD_SHORTCUT_TOGGLE_FINDER_LATENCY = 'keyboardShortcutToggleFinderLatency',
  KEYBOARD_SHORTCUT_TRAVERSE_CANVAS_LATENCY = 'keyboardShortcutTraverseCanvasLatency',
  KEYBOARD_SHORTCUT_UNSELECT_CANVAS_ELEMENT_LATENCY = 'keyboardShortcutUnselectCanvasElementLatency',
  KEYBOARD_SHORTCUT_ADD_CLASS_LATENCY = 'keyboardShortcutAddClassLatency',
  REMOVE_CANVAS_ELEMENT_LATENCY = 'removeCanvasElementLatency',
  CANVAS_PASTE_LATENCY = 'canvasPasteLatency',
  CLASS_NAME_EDITING_LATENCY = 'classNameEditingLatency',
  CANVAS_EDIT_TO_RENDER_LATENCY = 'canvasEditToRenderLatency',
  VARIABLE_VALUE_CHANGE_TO_RENDER_LATENCY = 'variableValueChangeToRenderLatency',
  VARIABLE_VALUE_CHANGE_DROPPED = 'variableValueChangeDropped',
  MAIN_COMPONENT_EDIT_TO_RENDER_LATENCY = 'mainComponentEditToRenderLatency',
  OPEN_PUBLISH_MODAL_LATENCY = 'openPublishModalLatency',
  BOUND_CANVAS_TEXT_SAVING_LATENCY = 'boundCanvasTextSavingLatency',
  COLLECTION_ITEM_EDIT_SAVING_LATENCY = 'collectionItemEditSavingLatency',
  CMS_ITEM_LOCALE_SWITCHED_AND_INTERACTIVE_LATENCY = 'cmsItemLocaleSwitchedAndInteractive',
  WORKSPACE_LIBRARY_ASSET_IMPORT_LATENCY = 'workspaceLibraryAssetImport',
  WORKSPACE_LIBRARY_INSTALL_LATENCY = 'workspaceLibraryInstall',
  WORKSPACE_LIBRARY_UPDATE_LATENCY = 'workspaceLibraryUpdate',
  WORKSPACE_LIBRARY_UNINSTALL_LATENCY = 'workspaceLibraryUninstall',
  ORION_APP_SWITCHED_LATENCY = 'orionAppSwitchedLatency',
  ORION_APP_LOAD_TO_HEALTHY_LATENCY = 'orionAppLoadToHealthyLatency',
  SUGGESTED_PROPS_GENERATION_LATENCY = 'suggestedPropsGenerationLatency',
  RENUMBER_DUPLICATE_SUGGESTIONS_LATENCY = 'renumberDuplicateSuggestionsLatency',
  PAGE_LIST_SEARCH_LATENCY = 'pageListSearchLatency',
  AGENT_PRESENCE_NATIVE_ID_PATH_RESOLUTION_LATENCY = 'agentPresenceNativeIdPathResolutionLatency',
}
